import { ArrowRight, ListTree, RefreshCcw, Route } from "lucide-react";

export default function CurrentWorkflowCard({ workflow, onRefresh, onMove, refreshing = false }) {
  const stageName = workflow?.current_stage?.name || "No stage assigned";
  const activityName = workflow?.current_node?.name || "No current activity";
  const stageOrder = workflow?.current_stage?.display_order;

  return (
    <div className="relative overflow-hidden bg-gradient-to-br from-slate-950 via-slate-900 to-blue-950 px-5 py-5 text-white sm:px-6">
      <div className="absolute -right-16 -top-20 h-48 w-48 rounded-full bg-blue-500/20 blur-3xl" />
      <div className="relative flex items-start justify-between gap-4">
        <div className="min-w-0">
          <span className="inline-flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-[0.16em] text-blue-200">
            <Route className="h-3.5 w-3.5" /> Active journey
          </span>

          <div className="mt-4 flex min-w-0 flex-col gap-3 sm:flex-row sm:items-center sm:gap-4">
            <div className="min-w-0">
              <p className="text-xs font-medium text-slate-400">
                Current stage{stageOrder ? ` · Stage ${stageOrder}` : ""}
              </p>
              <p className="mt-0.5 truncate text-base font-semibold text-white sm:max-w-[22rem]">
                {stageName}
              </p>
            </div>

            <ArrowRight className="hidden h-4 w-4 shrink-0 text-blue-300 sm:block" aria-hidden="true" />

            <div className="min-w-0 border-t border-white/10 pt-3 sm:border-l sm:border-t-0 sm:pl-4 sm:pt-0">
              <p className="text-xs font-medium text-slate-400">Next action</p>
              <h3 className="mt-0.5 truncate text-xl font-semibold tracking-tight sm:max-w-[24rem] sm:text-2xl">
                {activityName}
              </h3>
            </div>
          </div>
        </div>

        <div className="flex shrink-0 items-center gap-2">
          <button
            type="button"
            onClick={onMove}
            className="inline-flex h-10 items-center gap-2 rounded-xl border border-white/10 bg-white/10 px-3 text-xs font-semibold text-blue-50 transition hover:bg-white/15 hover:text-white"
            title="Jump to any stage or activity"
          >
            <ListTree className="h-4 w-4" /> <span className="hidden sm:inline">Jump</span>
          </button>
          <button
            type="button"
            onClick={onRefresh}
            disabled={refreshing}
            className="group flex h-10 w-10 items-center justify-center rounded-xl border border-white/10 bg-white/10 text-slate-200 transition hover:bg-white/15 hover:text-white disabled:cursor-wait disabled:opacity-70"
            title={refreshing ? "Refreshing journey" : "Refresh journey"}
            aria-label={refreshing ? "Refreshing journey" : "Refresh journey"}
          >
            <RefreshCcw className={`h-4 w-4 ${refreshing ? "animate-spin" : "transition-transform group-hover:-rotate-45"}`} />
          </button>
        </div>
      </div>
    </div>
  );
}
